import { render, staticRenderFns } from "./CacheDeletion.vue?vue&type=template&id=70af01b9&"
import script from "./CacheDeletion.vue?vue&type=script&lang=js&"
export * from "./CacheDeletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports